import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgxKjuaModule } from 'ngx-kjua';
import { WireTransferSuccessModalComponent } from './wire-transfer-success-modal.component';
import { SmallToCryptoPipeModule } from 'src/app/angular-wallet-base/pipes/smalltocrypto/smalltocrypto.module';
import { CustomCurrencyPipeModule } from 'src/app/angular-wallet-base/pipes/customcurrency/customcurrency.module';

@NgModule({
  imports: [
    NgxKjuaModule,
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    SmallToCryptoPipeModule,
    CustomCurrencyPipeModule
  ],
  exports: [],
  declarations: [WireTransferSuccessModalComponent],
  providers: []
})
export class WireTransferSuccessModalModule {
}